import { useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { Button } from 'reactstrap';

import NotFoundPage from 'src/components/layout/NotFound';

import { CalendarPlusSvg } from 'src/components/icons/Icon';
import AvailabilitySubmittedSuccess from 'src/pages/SelectAvailability/Components/AvailabilitySubmittedSuccess';
import { fetchResidentAvailabilities, getResidentAvailabilitiesForesight } from 'src/services/resident-availability';
import { useActiveStepContext } from 'src/components/context/ActiveStepContext';
import { useResidentAvailabilitiesContext } from 'src/components/context/ResidentAvailibilitiesContext';

const ChooseAvailabilitySelect = () => {
  const {
    submittedAvailabilities,
    setSubmittedAvailabilities,
  } = useResidentAvailabilitiesContext();

  const [isDataFetching, setIsDataFetching] = useState(true);
  const [hasErrors, setHasErrors] = useState('');
  const { tenantAccessCode, tenantContactHash } = useParams();
  const { setActiveStep } = useActiveStepContext();

  const handleActiveStep = useCallback(() => {
    setActiveStep('step_2');
  }, [setActiveStep]);

  const getLulaResidentAvailability = useCallback(() => {
    if (tenantAccessCode) {
      fetchResidentAvailabilities(
        tenantAccessCode,
        tenantContactHash ? { tenant_code: tenantContactHash } : {},
      )
        .then((res) => {
          if (res) {
            setSubmittedAvailabilities(res);
          }
        })
        .catch((error) => {
          setHasErrors(error?.data?.message || 'Something went wrong. Please try again.');
        })
        .finally(() => {
          setIsDataFetching(false);
        });
    }
  }, [setSubmittedAvailabilities, tenantAccessCode, tenantContactHash]);

  const getForesightResidentAvailability = useCallback(() => {
    if (tenantAccessCode) {
      getResidentAvailabilitiesForesight(tenantAccessCode)
        .then((res) => {
          setSubmittedAvailabilities(res);
        })
        .catch((error) => {
          setHasErrors(error?.data?.message || 'Something went wrong. Please try again.');
        })
        .finally(() => {
          setIsDataFetching(false);
        });
    }
  }, [setSubmittedAvailabilities, tenantAccessCode]);

  useEffect(() => {
    if (import.meta.env.VITE_PLATFORM === 'lula') {
      getLulaResidentAvailability();
    }
    if (import.meta.env.VITE_PLATFORM === 'foresight') {
      getForesightResidentAvailability();
    }
  }, [getForesightResidentAvailability, getLulaResidentAvailability]);

  if (isDataFetching) {
    return <div className="ra-loader" />;
  }

  if (hasErrors) {
    return <NotFoundPage errorMessage={hasErrors} />;
  }

  if (!isDataFetching
    && !!submittedAvailabilities?.resident_availability?.length
    && !submittedAvailabilities?.is_editable) {
    return (
      <AvailabilitySubmittedSuccess />
    );
  }

  return (
    <div className="availability-submission">
      <div className="icon">
        <CalendarPlusSvg />
      </div>
      <h3 className="h4">Submit Availability</h3>
      <p>Select at least 3 days for quicker resolution</p>
      <Button
        label="Choose Availability"
        onClick={handleActiveStep}
        className="primary-button btn-block btn btn-secondary"
      >
        Choose Availability
      </Button>
    </div>
  );
};

export default ChooseAvailabilitySelect;
